import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'

const FooterContent = () => {
  const theme = useTheme()
  // ** Var
  // const hidden = useMediaQuery(theme => theme.breakpoints.down('md'))
  const hidden = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography sx={{ mr: 2 }}>
        {`© ${new Date().getFullYear()}, `}
        <Link target='_blank' href='https://www.aladdinsci.net'>
          Aladdin Scientific
        </Link>
      </Typography>
    </Box>
  )
}

export default FooterContent
